import React, { Fragment } from 'react'
import { Breadcrumb, Card, Row, Tabs } from 'antd'
import { get } from 'lodash'
import List from './List'
import DeliverModal from './Delivery/DeliverModal'
import IconText from '../../../../elements/IconText'
import { withRouter } from 'react-router-dom'
import DeliveryList from './Delivery/DeliveryList'
import VehicleList from './Vehicles/VehicleList'
import VehicleModal from './Vehicles/VehicleModal'
import SalikList from './Salik/SalikList'
import SalikModal from '../../../../components/Operations/Transport/Management/Salik/SalikModal'
import FuelLinesCont from '../../../../components/Operations/Transport/Management/FuelLines/FuelLinesCont'

const { TabPane } = Tabs

function Transport(props) {
  return (
    <Fragment>
      <Card>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Operations</Breadcrumb.Item>
            <Breadcrumb.Item>Transport</Breadcrumb.Item>
          </Breadcrumb>
          <h2>Transport</h2>
          <p>View and list Transports bookings.</p>
        </Row>
      </Card>
      <Card>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#bookings'} onChange={(key) => props.history.push(key)}>
          <TabPane tab={<IconText text={'Bookings'} type={'calendar'} />} key="#bookings">
            <DeliverModal {...props} />
            <List {...props} />
          </TabPane>
          <TabPane tab={<IconText text={'Deliveries'} type={'schedule'} />} key="#deliveries">
            <DeliveryList {...props} />
          </TabPane>
          <TabPane tab={<IconText text={'Vehicles'} type={'car'} />} key="#vehicles">
            <VehicleModal {...props} />
            <VehicleList {...props} />
          </TabPane>
          <TabPane tab={<IconText text={'Salik'} type={'car'} />} key="#salik">
            <SalikModal {...props} />

            <SalikList {...props} />
          </TabPane>
          <TabPane tab={<IconText text={'Fuel Lines'} type={'experiment'} />} key="#fuel-lines">
            <FuelLinesCont />
          </TabPane>
        </Tabs>
      </Card>
    </Fragment>
  )
}

export default withRouter(Transport)
